const organizationsSearchActions = {
  ORG_SEARCH_INIT_STATE_SET: 'ORG_SEARCH_INIT_STATE_SET',
  ORG_SEARCH_PROP_UPDATE: 'ORG_SEARCH_PROP_UPDATE',
  ORG_SEARCH_PROP_DELETE: 'ORG_SEARCH_PROP_DELETE'
};
export default organizationsSearchActions;
